import React from 'react';

const SkillsAnalytics: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow border p-6">
      <h2 className="text-xl font-semibold mb-2">Analytics</h2>
      <p className="text-gray-600">Analytics dashboards coming soon.</p>
    </div>
  );
};

export default SkillsAnalytics;


